import { BaseModel } from "sjs-base-model";
import CampaignMappingDataHitsModel from "./CampaignMappingDataHitsModel";

// get model for project
export default class CampaignMappingHitsModel extends BaseModel {
  /*
   * Client-Side properties (Not from API)
   */
  // noneApiProperties = null;
  // response getting from the api mentioned end point

  hits = [{ CampaignMappingDataHitsModel }];

  constructor(data1) {
    super();

    this.update(data1);
  }
}
